/* 🤖 this file was generated by svg-to-ts */
export const matIconEnhancedEncryption: {
  name: 'enhanced-encryption';
  data: string;
} = {
  name: 'enhanced-encryption',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10zm-5-9h-2v3H8v2h3v3h2v-3h3v-2h-3z"/></svg>`
};
